import pivotreeLogo from './pivotree-logo-white.png';

export const LogoIcon = () => (
  <img
    src={pivotreeLogo}
    alt="Pivotree"
    style={{ height: 28, width: 'auto', display: 'block' }}
  />
);
